import { type MetricField } from "../../gql-generated/types";
import { formatNumbers } from "../../lens-stats/formatters";
import { getKeys } from "../../shared/utils/object";
import { summarizeMetricsArray } from "../math";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

export const mapComputedTotalValues = (
    metrics: Partial<Record<MetricField, InsightsMetrics<StatsItem>>>,
): InsightsMetricsMap<StatsItem> => {
    getKeys(metrics).forEach((item: MetricField) => {
        const metric = metrics[item];
        if (metric) {
            const totalValue = summarizeMetricsArray(metric.stats);

            metric.totalValue = totalValue;
            if (totalValue) {
                metric.totalValueFormatted = formatNumbers(totalValue);
            }
        }
    });

    return metrics;
};
